import { ReactNode } from 'react';
import Head from 'next/head';
import Script from 'next/script';
import DefaultLayout from 'components/layouts/DefaultLayout';
import styled from 'styled-components';
import { mediaMSmMax } from 'helpers/breakpoints';
import { AuthWrapper } from 'components/auth_flow/SharedComponents';
import { useRouter } from 'next/router';
import getConfig from 'next/config';

export default function SignUpLayout({ children }: { children: ReactNode }) {
  const { asPath } = useRouter();

  const { RAILS_URL } = getConfig().publicRuntimeConfig;

  return (
    <DefaultLayout hideFooter hideNav white>
      <Head>
        <meta name="robots" content="noindex" />
        {/* eslint-disable-next-line @next/next/no-sync-scripts */}
        <script crossOrigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js" />
        <link rel="canonical" href={`${RAILS_URL}${asPath}`} />
      </Head>

      <Script
        strategy="beforeInteractive"
        type="text/javascript"
        src="https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js"
      />

      <Wrapper>
        <AuthWrapper>{children}</AuthWrapper>
      </Wrapper>
    </DefaultLayout>
  );
}

const Wrapper = styled.div`
  padding-top: 90px;

  display: flex;
  flex-flow: column;
  width: 420px;
  margin: auto;

  ${mediaMSmMax} {
    padding: 70px 22px 0 22px;
    width: auto;
  }
`;
